import React from 'react';

export const SourceTypeInteger = (props: { size: number } = { size: 24 }) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="new-Icon/source_integer"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="source_integer">
        <rect
          id="bck-SorceDataType"
          fill="#575757"
          x="0"
          y="0"
          width="32"
          height="32"
          rx="2"
        ></rect>
        <path
          d="M6.66666667,23.1893333 L6.66666667,8 L8.84266667,8 L8.84266667,23.1893333 L6.66666667,23.1893333 Z M10.8693333,23.1893333 L10.8693333,8 L12.96,8 L16.2453333,17.152 L16.288,17.152 L16.288,8 L18.464,8 L18.464,23.1893333 L16.416,23.1893333 L13.088,14.0586667 L13.0453333,14.0586667 L13.0453333,23.1893333 L10.8693333,23.1893333 Z M21.856,23.1893333 L21.856,10.048 L19.3386667,10.048 L19.3386667,8 L26.5493333,8 L26.5493333,10.048 L24.032,10.048 L24.032,23.1893333 L21.856,23.1893333 Z"
          id="INT"
          fill="#FFFFFF"
        ></path>
      </g>
    </g>
  </svg>
);
